module.exports = __webpack_public_path__ + "static/logo.f835bcdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/logo.svg
// module id = 51
// module chunks = 22676092666560 221374088121123